class ShopTheLookCollection extends HTMLElement {
  constructor() {
    super();
    this.initBreakpoints();
    this.triggers = document.querySelectorAll(
      "[data-external-shop-the-look-trigger]"
    );
    this.container = this;
    this.shopLookContent = this.querySelector(".shop-look__content");
    this.modalWrap = this.querySelector(".shop-look__modal-drawer");
    this.modal = this.querySelector(".shop-look__modal");
    this.closeButton = this.modalWrap.querySelector(".btn-close-modal-text");
    this.lookGroups = this.modalWrap.querySelectorAll(".shop-look__item-wrap");
    this.onContainerClick = this.handleContainerClick.bind(this);
    this.isVisible = () =>
      this.modalWrap.classList.contains("shop-look__modal-drawer--open");

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", this.handleTriggerClick.bind(this));
    });

    this.closeButton.addEventListener("click", this.closeModal.bind(this));
  }

  initBreakpoints() {
    const self = this;

    enquire.register("screen and (min-width: 768px) and (max-width: 1024px)", {
      match: () => {
        this.bpTablet = true;
      },
      unmatch: () => {
        this.bpTablet = false;
      },
    });
  }

  handleTriggerClick(e) {
    e.preventDefault();
    const currentTarget = e.currentTarget;
    const expanded = currentTarget.getAttribute("aria-expanded");
    const productGroupIndex = currentTarget.dataset.lookDot;

    if (expanded === "true") {
      currentTarget.setAttribute("aria-expanded", "false");
      this.closeModal();
    } else {
      this.triggers.forEach((trigger) => {
        trigger.setAttribute("aria-expanded", "false");
      });
      currentTarget.setAttribute("aria-expanded", "true");
      this.activeElement = currentTarget;
      this.updateModalContent(productGroupIndex);
    }
  }

  updateModalContent(productGroupIndex) {
    let galleries;

    this.modal.style.height = "";
    this.modal.style.transition = "none";
    const startHeight = window.getComputedStyle(this.modal).height;

    this.lookGroups.forEach((item) => {
      const itemIndex = item.dataset.lookGroup;

      if (
        item.classList.contains("shop-look__item-wrap--active") &&
        itemIndex !== productGroupIndex
      ) {
        item.classList.remove("shop-look__item-wrap--active");
        item.addEventListener(
          "transitionend",
          () => {
            if (!item.classList.contains("shop-look__item-wrap--active")) {
              item.style.display = "none";
            }
          },
          { once: true }
        );
      }

      if (itemIndex === productGroupIndex) {
        item.style.removeProperty("display");
        setTimeout(() => item.classList.add("shop-look__item-wrap--active"), 0);

        galleries = item.querySelectorAll("lite-gallery");
      } else {
        item.style.display = "none";
      }
    });

    if (galleries && galleries.length) {
      galleries.forEach((gallery) => {
        const productGallery = gallery.querySelector(
          ".product-single__gallery"
        );
        const galleryNav = gallery.querySelector(".product-single__thumbnails");

        if (productGallery) $(productGallery).slick("refresh");
        if (galleryNav) $(galleryNav).slick("refresh");
      });
    }

    const height = window.getComputedStyle(this.modal).height;
    this.modal.style.height = startHeight;

    requestAnimationFrame(() => {
      this.modal.style.transition = "";

      requestAnimationFrame(() => {
        this.modal.style.height = height;
      });
    });

    this.modalWrap.addEventListener(
      "transitionend",
      () => {
        this.modal.style.height = "";
      },
      { once: true }
    );

    this.openModal(galleries);
  }

  openModal(galleries) {
    this.modalWrap.style.removeProperty("display");
    setTimeout(
      () => this.modalWrap.classList.add("shop-look__modal-drawer--open"),
      0
    );
    this.classList.add("active");

    this.container.addEventListener("click", this.onContainerClick);

    const containerHeight = this.shopLookContent.offsetHeight;
    const modalHeight = this.modalWrap.offsetHeight + 20;

    if (this.bpTablet && containerHeight < modalHeight) {
      this.shopLookContent.style.height = `${modalHeight}px`;
    }

    if (galleries.length) {
      galleries.forEach((gallery) => {
        const productGallery = gallery.querySelector(
          ".product-single__gallery"
        );
        const galleryNav = gallery.querySelector(".product-single__thumbnails");

        if (productGallery) $(productGallery).slick("refresh");
        if (galleryNav) $(galleryNav).slick("refresh");
      });
    }

    this.modalWrap.addEventListener(
      "transitionend",
      () => {
        this.modalWrap.focus();
        trapFocus(this.modalWrap);
      },
      { once: true }
    );
  }

  closeModal(e) {
    this.modalWrap.classList.remove("shop-look__modal-drawer--open");
    this.classList.remove("active");

    this.triggers.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });

    this.container.removeEventListener("click", this.onContainerClick);
    if (this.bpTablet) {
      this.shopLookContent.style.height = null;
    }

    this.modalWrap.addEventListener(
      "transitionend",
      () => {
        if (!this.isVisible()) {
          this.modalWrap.style.display = "none";
        }
      },
      { once: true }
    );

    removeTrapFocus(this.activeElement);
  }

  handleContainerClick(e) {
    if (
      (e.target && e.target.classList.contains("shop-look__content")) ||
      e.target.classList.contains("shop-look-section") ||
      e.target.classList.contains("shop-look__modal-wrap")
    ) {
      this.closeModal();
    }
  }
}

customElements.define("shop-the-look-collection", ShopTheLookCollection);
